import gql from 'graphql-tag';

/**
 * GQL Delete Preventive Maintenance Schedule Mutation
 */

export const deletePMScheduleMutation = gql`
  mutation deletePMScheduleMutation($scheduleId: String!) {
    deletePMSchedule(scheduleId: $scheduleId)
  }
`;
